import React from 'react';

import { Form, Upload } from 'antd';

import { AddCircle, Gallery, Trash } from '../../../assets/icons';
import { FILE_UPLOAD_VALIDATION } from '../../../utils/fileValidation';

export const UploadField = ({
  className,
  onChangeHandle,
  fileList,
  handleRemoveUploaded,
  id,
  beforeUpload,
  label,
  fileValidate = false,
  fileSizeValidate = false,
  loading = false,
}) => {
  return (
    <Form.Item className={className}>
      <Upload
        id={id}
        accept='image/png, image/jpeg, image/jpg'
        onChange={onChangeHandle}
        showUploadList={{
          showRemoveIcon: false,
          showPreviewIcon: false,
        }}
        fileList={fileList}
        className='avatar-uploader'
        listType='picture-card'
        beforeUpload={beforeUpload}
        disabled={loading}
      >
        {fileList.length < 1 && (
          <div>
            <AddCircle />
            <p className='fw-600'>{label}</p>
          </div>
        )}
      </Upload>
      {fileList[0] && (
        <div className='filename'>
          <span>
            <Gallery verticalAlign='middle' marginRight='7px' />
            {fileList[0].name}
          </span>
          <Trash verticalAlign='middle' className='delete-icon' onClick={() => handleRemoveUploaded(fileList[0].uid, 'front')} />
        </div>
      )}
      {fileValidate === true && (
        <p className='error' style={{ color: 'red', paddingTop: 10 }}>
          {FILE_UPLOAD_VALIDATION.FORMAT}
        </p>
      )}
      {fileSizeValidate === true && <p style={{ color: 'red', paddingTop: 10 }}>{FILE_UPLOAD_VALIDATION.FILE_SIZE}</p>}
    </Form.Item>
  );
};
